import { Value } from '@philips-internal/oswald-ui-core';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { Validation } from '@philips-internal/oswald-ui-core/lib/services/model-service';

interface CryptoPwMessageItemProps {
  key: string;
  message: string;
}

const CONFIRMATION_FIELD_VALID = 'confirmationField';
const CRYPTOPW_VALIDATOR = 'cryptoPWValidator';
const CRYPTOPW_VALIDATOR_DEPRECATED = 'cryptoPWValidatorDeprecated';
const NEW_CRYPTOPW_VALIDATOR = 'newCryptoPWValidator';

const cryptoPwMessageParams = new Map([
  [
    'minMax', [
      { regex: '#@MIN_CARACTER#@', value: '1'},
      { regex: '#@MAX_CARACTER#@', value: '16' }
    ]
  ]
]);

const cryptoPwMessageItem: CryptoPwMessageItemProps[] = [
  { key: 'minMax', message: 'patient.validator.password-message-01' },
  { key: 'lengthNumber', message: 'patient.validator.password-message-02' },
  { key: 'caseSensitive', message: 'patient.validator.password-message-03' },
  { key: 'lengthSymbol', message: 'patient.validator.password-message-04' },
];

function getMessageAndReplaceParam(messageItem: CryptoPwMessageItemProps): string {
  const message = MessageService.translate(messageItem.message);
  const messageParams = cryptoPwMessageParams.get(messageItem.key);

  if (messageParams != null && messageParams.length > 0) {
    let finalMessage = message;
    messageParams.forEach(param => {
      finalMessage = finalMessage.replace(param.regex, param.value);
    });
    return finalMessage;
  }

  return message;
}

async function confirmationFieldValidator(value: Value, confirmationValue: Value): Promise<Validation[]> {
  const valid = Boolean(value) && Boolean(confirmationValue) && confirmationValue === value;

  return [{
    message: !valid ? 'patient.passwords.donot.match' : 'patient.ok-password.confirmed',
    name: CONFIRMATION_FIELD_VALID,
    valid,
  }];
}

/**
 * For password reset and user registration, don't
 * use this validador.
 */
async function cryptoPWValidatorDeprecated(value: Value): Promise<Validation[]> {
  const pass = value as string || '';
  const valid = Boolean(pass.match(/^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/)) && pass.length >= 8 && pass.length <= 16;

  return [{
    message: !valid ? 'patient.reset-user.password-length-validator' : '',
    name: CRYPTOPW_VALIDATOR_DEPRECATED,
    valid,
  }];
}

async function cryptoPWValidator(value: Value): Promise<Validation[]> {
  const cryptopwRegex = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,16}$/);
  const valid = cryptopwRegex.test(String(value || ''));

  return cryptoPwMessageItem.map(item => ({
    message: getMessageAndReplaceParam(item),
    name: CRYPTOPW_VALIDATOR,
    valid
  }));
}

async function newCryptoPWValidatorValidator(value: Value, comparisonField: Value): Promise<Validation[]> {
  const valid = value !== comparisonField;

  return [{
    message: !valid ? 'patient.password.on-change.validation' : '',
    name: NEW_CRYPTOPW_VALIDATOR,
    valid,
  }];
}

function checkValidEmailList(emailList: Record<string, Value>[]): boolean {
  interface EmailFromFieldList {
    email: string;
  }
  let isValid = false;
  const EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
  const list = emailList;
  if (list) {
    isValid = true;
    (list as unknown as EmailFromFieldList[]).forEach(item=>{
      if ((!item.email) || (item.email.length == 0) || (!item.email.match(EMAIL))) {
        isValid = false;
      }
    });
  }
  return isValid;
}

export {
  confirmationFieldValidator,
  cryptoPWValidator,
  cryptoPWValidatorDeprecated,
  newCryptoPWValidatorValidator,
  NEW_CRYPTOPW_VALIDATOR,
  CRYPTOPW_VALIDATOR,
  CRYPTOPW_VALIDATOR_DEPRECATED,
  CONFIRMATION_FIELD_VALID,
  checkValidEmailList,
};

